"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECRPUBLIC = void 0;
const smithy_client_1 = require("@aws-sdk/smithy-client");
const BatchCheckLayerAvailabilityCommand_1 = require("./commands/BatchCheckLayerAvailabilityCommand");
const BatchDeleteImageCommand_1 = require("./commands/BatchDeleteImageCommand");
const CompleteLayerUploadCommand_1 = require("./commands/CompleteLayerUploadCommand");
const CreateRepositoryCommand_1 = require("./commands/CreateRepositoryCommand");
const DeleteRepositoryCommand_1 = require("./commands/DeleteRepositoryCommand");
const DeleteRepositoryPolicyCommand_1 = require("./commands/DeleteRepositoryPolicyCommand");
const DescribeImagesCommand_1 = require("./commands/DescribeImagesCommand");
const DescribeImageTagsCommand_1 = require("./commands/DescribeImageTagsCommand");
const DescribeRegistriesCommand_1 = require("./commands/DescribeRegistriesCommand");
const DescribeRepositoriesCommand_1 = require("./commands/DescribeRepositoriesCommand");
const GetAuthorizationTokenCommand_1 = require("./commands/GetAuthorizationTokenCommand");
const GetRegistryCatalogDataCommand_1 = require("./commands/GetRegistryCatalogDataCommand");
const GetRepositoryCatalogDataCommand_1 = require("./commands/GetRepositoryCatalogDataCommand");
const GetRepositoryPolicyCommand_1 = require("./commands/GetRepositoryPolicyCommand");
const InitiateLayerUploadCommand_1 = require("./commands/InitiateLayerUploadCommand");
const ListTagsForResourceCommand_1 = require("./commands/ListTagsForResourceCommand");
const PutImageCommand_1 = require("./commands/PutImageCommand");
const PutRegistryCatalogDataCommand_1 = require("./commands/PutRegistryCatalogDataCommand");
const PutRepositoryCatalogDataCommand_1 = require("./commands/PutRepositoryCatalogDataCommand");
const SetRepositoryPolicyCommand_1 = require("./commands/SetRepositoryPolicyCommand");
const TagResourceCommand_1 = require("./commands/TagResourceCommand");
const UntagResourceCommand_1 = require("./commands/UntagResourceCommand");
const UploadLayerPartCommand_1 = require("./commands/UploadLayerPartCommand");
const ECRPUBLICClient_1 = require("./ECRPUBLICClient");
const commands = {
    BatchCheckLayerAvailabilityCommand: BatchCheckLayerAvailabilityCommand_1.BatchCheckLayerAvailabilityCommand,
    BatchDeleteImageCommand: BatchDeleteImageCommand_1.BatchDeleteImageCommand,
    CompleteLayerUploadCommand: CompleteLayerUploadCommand_1.CompleteLayerUploadCommand,
    CreateRepositoryCommand: CreateRepositoryCommand_1.CreateRepositoryCommand,
    DeleteRepositoryCommand: DeleteRepositoryCommand_1.DeleteRepositoryCommand,
    DeleteRepositoryPolicyCommand: DeleteRepositoryPolicyCommand_1.DeleteRepositoryPolicyCommand,
    DescribeImagesCommand: DescribeImagesCommand_1.DescribeImagesCommand,
    DescribeImageTagsCommand: DescribeImageTagsCommand_1.DescribeImageTagsCommand,
    DescribeRegistriesCommand: DescribeRegistriesCommand_1.DescribeRegistriesCommand,
    DescribeRepositoriesCommand: DescribeRepositoriesCommand_1.DescribeRepositoriesCommand,
    GetAuthorizationTokenCommand: GetAuthorizationTokenCommand_1.GetAuthorizationTokenCommand,
    GetRegistryCatalogDataCommand: GetRegistryCatalogDataCommand_1.GetRegistryCatalogDataCommand,
    GetRepositoryCatalogDataCommand: GetRepositoryCatalogDataCommand_1.GetRepositoryCatalogDataCommand,
    GetRepositoryPolicyCommand: GetRepositoryPolicyCommand_1.GetRepositoryPolicyCommand,
    InitiateLayerUploadCommand: InitiateLayerUploadCommand_1.InitiateLayerUploadCommand,
    ListTagsForResourceCommand: ListTagsForResourceCommand_1.ListTagsForResourceCommand,
    PutImageCommand: PutImageCommand_1.PutImageCommand,
    PutRegistryCatalogDataCommand: PutRegistryCatalogDataCommand_1.PutRegistryCatalogDataCommand,
    PutRepositoryCatalogDataCommand: PutRepositoryCatalogDataCommand_1.PutRepositoryCatalogDataCommand,
    SetRepositoryPolicyCommand: SetRepositoryPolicyCommand_1.SetRepositoryPolicyCommand,
    TagResourceCommand: TagResourceCommand_1.TagResourceCommand,
    UntagResourceCommand: UntagResourceCommand_1.UntagResourceCommand,
    UploadLayerPartCommand: UploadLayerPartCommand_1.UploadLayerPartCommand,
};
class ECRPUBLIC extends ECRPUBLICClient_1.ECRPUBLICClient {
}
exports.ECRPUBLIC = ECRPUBLIC;
(0, smithy_client_1.createAggregatedClient)(commands, ECRPUBLIC);
